import { ProfileService } from '@shared/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { AuthLogoutAction } from '@shared/store/actions/auth-actions';
import { AuthService } from '@shared/store';
import { getLayoutEnableAdminOptions, getLayoutShowSidebav } from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { lastBuild } from '@spaq/configs/last-build';
import * as moment from 'moment';

@Component({
	selector: 'spaq-layout-account-sidebar',
	templateUrl: './layout-account-sidebar.component.html',
	styleUrls: ['./layout-account-sidebar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutAccountSidebarComponent implements OnInit {
	lastBuild = '';
	avatar = '/assets/spaq-logo-wb.jpg';
	enableAdminOptions$ = this.store.pipe(select(getLayoutEnableAdminOptions));
	@Output() clickAdminMenu = new EventEmitter();
	@Output() clickEnableAdminOptions = new EventEmitter();
	@Output() clickUserMenu = new EventEmitter();

	@Input() enableAdminOptions = false;
	haveContract = false;
	hide$: Observable<boolean> = of(false);
	@Input() isAdmin = false;
	@Input() isAdminMenu = false;
	@Input() isStaff = false;
	@Input() items = [];
	@Output() onClick = new EventEmitter();
	@Input() selectedGroup = '';
	@Input() selectedItem = '';

	constructor(
		private store: Store<any>,
		private router: Router,
		private afAuth: AngularFireAuth,
		private auth: AuthService,
		public profileService: ProfileService
	) {
		this.hide$ = this.store.select(getLayoutShowSidebav);
		this.lastBuild = `${moment(lastBuild).format('LL')} (${moment(lastBuild).fromNow()})`;
	}

	ngOnInit() {}

	click($event, item) {
		this.onClick.emit(item);
		$event.preventDefault();
	}

	logout() {
		this.store.dispatch(new AuthLogoutAction());
	}

	onClickAdminMenu() {
		this.clickAdminMenu.emit();
	}

	onClickEnableAdminOptions() {
		this.clickEnableAdminOptions.emit();
	}

	onClickUserMenu() {
		this.clickUserMenu.emit();
	}
}
